import { render, staticRenderFns } from "./PatientViewer.vue?vue&type=template&id=535333ab&scoped=true&"
import script from "./PatientViewer.vue?vue&type=script&lang=ts&"
export * from "./PatientViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PatientViewer.vue?vue&type=style&index=0&id=535333ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535333ab",
  null
  
)

export default component.exports